























import { Component as NodeComponent } from 'vue'
import { Vue, Component, Watch } from 'vue-property-decorator'
import {
  TreeList,
  PageRuleSortList,
  EntryAllCfg,
  EntryHomeCardListMap,
  PropsalTabsListMap
} from '@/types/newPersion'

import { cloneDeep } from 'lodash'
import { propsalTabsListClone, pageRuleSortList } from '@/views/newPension/utils/default'

import StoryLayout from '@/common/cardMap/storyLayout/index.vue'
import cardContainer from '@/common/cardMap/cardLayout/cardContainer.vue'
import cardWraper from '@/common/cardMap/cardLayout/cardWraper.vue'
import cardTable from '@/common/cardMap/cardLayout/cardTable.vue'
import cardTableInfo from '@/common/cardMap/cardLayout/cardTableInfo.vue'
import IoCard from '@/common/cardMap/cardLayout/ioCard.vue'
import OutCard from '@/common/cardMap/cardLayout/out-card.vue'

import BaseInfo from '@/views/newPension/components/baseInfo/index.vue'

import HomeCard from '@/views/newPension/homeCard/index.vue' // 首页展示卡片
import TotalDetail from '@/views/newPension/totalDetail/index.vue' // 查看详情

import PropsalPage from '@/views/newPension/pensionCard/proposal/index.vue' // 产品规划建议

import CoverPage from '@/common/cardMap/coverCard/index.vue' // 封面图
import DemandTargetPage from './pensionCard/demandTarget/index.vue' // 退休规划目标核酸
import ReserveAnalysisPage from './pensionCard/reserveAnalysis/index.vue' // 退休规划目标核酸
import DemandPage from './pensionCard/demand/index.vue' // 养老需求分析
import SupplyPage from './pensionCard/supply/index.vue' // 养老供给分析
import EmptyPage from './pensionCard/empty/index.vue' // 空白页面(兜底)

import Test from './test.vue'
import { storyUserType } from '@/api/users'
import { fetchIasDetail } from '@/api/tenant/calcGroup'

@Component({
  components: {
    cardContainer,
    cardWraper,
    cardTable,
    cardTableInfo,
    IoCard,
    OutCard,
    StoryLayout,
    Test,
    HomeCard,

    BaseInfo
  },
})
export default class extends Vue {
  private page: NodeComponent | null = null;
  entryAllCfg: EntryAllCfg = {
    homeCardList: [
      {
        type: 'demand',
        page: DemandTargetPage,
        icon: 'el-icon-date',
        title: '设定需求目标',
        desc: '您的财富规划目标',
        status: false,
      },
      {
        type: 'finance',
        page: ReserveAnalysisPage,
        icon: 'el-icon-tickets',
        title: '财务储备分析',
        desc: '您的财务收入情况',
        status: false,
      },
      {
        type: 'proposal',
        page: PropsalPage,
        icon: 'el-icon-paperclip',
        title: '产品规划建议',
        desc: '满足您需求目标的规划建议',
        status: false,
        propsalTabsObj: {
          propsalTabsList: [],
          type: '', // annuity
        },
      },
    ],
    entryPageCfg: undefined,
  };

  treeList: TreeList[] | null = null;
  pageRuleSortList: PageRuleSortList[] | null = null;
  storyLineUrl = '';
  route = '';
  private created () {
    this.handlePage()
  }

  @Watch('$route')
  handleUpdate () {
    this.handlePage(this.handleRouteParamsType())
  }

  // 触发步骤状态
  private handleChangStepStatus (statusLsst: boolean[]) {
    for (let i = 0; i < statusLsst.length; i++) {
      this.entryAllCfg.homeCardList[i].status = statusLsst[i]
    }
  }

  private handleEditBtn () {
    this.entryAllCfg.entryPageCfg = undefined
  }

  private handleToPage ({ type, page }: EntryHomeCardListMap, idx: number) {
    this.entryAllCfg.entryPageCfg = {
      idx,
      type,
      page,
    }
  }

  private handleRouteParamsType () {
    return this.$route.params.type
  }

  private async getTreeListData () {
    this.storyLineUrl =
      (await storyUserType({ storyLineType: 'Pension' })).data.storyLineUrl ||
      ''
    const trees = await fetchIasDetail({
      id: (await storyUserType({ storyLineType: 'Pension' })).data.iasGroupId,
    })

    if (trees?.data?.computeModelTree?.branch) {
      const _computeTrees = trees.data.computeModelTree.branch[0].subBranch
      const _productTrees = trees.data.productModelTree.branch
      const _pageRuleSortList = cloneDeep(pageRuleSortList)

      _computeTrees.forEach((item: TreeList) => {
        _pageRuleSortList.forEach((v) => {
          const _subBranch = item.subBranch
          if (item.name.includes(v.name) && _subBranch) {
            const _find = _subBranch.find((n) => n.selected)
            if (_find) {
              v.status = true
              v.id = _find.id
            }
          }
        })
      })
      // 处理 步骤三 tab栏显示内容
      this.handleProductTree(_productTrees)
      this.pageRuleSortList = _pageRuleSortList

      if (this.handleRouteParamsType()) {
        this.handlePage(this.handleRouteParamsType())
        return
      }
      for (let i = 0; i < this.pageRuleSortList.length; i++) {
        const { status, page } = this.pageRuleSortList[i]
        if (status) {
          this.handlePage(page)
          break
        }
      }
    }
  }

  private handleProductTree (list: TreeList[]) {
    const _arr: PropsalTabsListMap[] = []
    list.forEach((item: TreeList) => {
      item.subBranch && item.subBranch.forEach((w: TreeList) => {
        if (w.selected) {
          const _find = propsalTabsListClone.find(item => item.typeName === w.name)
          if (_find) {
            _arr.push(cloneDeep(_find))
          }
        }
      })
    })

    if (!_arr.length) {
      this.$message({
        type: 'warning',
        message: '请先选择寿险/投资产品，在进行养老规划。'
      })
      return
    }
    if (this.entryAllCfg.homeCardList[2].propsalTabsObj) {
      this.entryAllCfg.homeCardList[2].propsalTabsObj.propsalTabsList = _arr
      this.entryAllCfg.homeCardList[2].propsalTabsObj.type = _arr[0].type
    }
  }

  private handleFindIdx (_page: string) {
    const _list = this.pageRuleSortList || []
    return _list.findIndex((item) => item.page === _page) + 1
  }

  private handlePage (type?: string) {
    if (type) {
      this.handleCoverPage(type)
      switch (type) {
        case 'supply':
          this.page = SupplyPage
          break
        case 'target':
          this.page = DemandTargetPage
          break
        case 'demand':
          this.page = DemandPage
          break
        case 'test':
          this.page = Test
          break
        case 'empty':
          this.page = EmptyPage
          // this.page = CoverPage
          break
        case 'totalDetail':
          this.handleToTotalDetailPage()
          break
        case 'homeCard':
          this.page = HomeCard
          break
        case 'cover':
        default:
          this.page = CoverPage
          break
      }
    } else {
      this.getTreeListData()
    }
  }

  private handleToTotalDetailPage () {
    let flag = false
    const { homeCardList } = this.entryAllCfg
    for (let i = 0; i < homeCardList.length; i++) {
      const homeCardListItem = homeCardList[i]
      if (homeCardListItem.status) {
        flag = true
        break
      }
    }
    if (flag) {
      this.page = TotalDetail
    } else {
      this.$message({
        type: 'warning',
        message: '请先输入您的需求目标，再查看详情'
      })
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private handleCoverPage (_page: string) {
    this.route = '/pension/card/homeCard'
  }
}
